module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/instagram/sola_sns_05-c4c778dfdca58920c031035fa4dd3620.jpg";